import { Record } from 'immutable';
import { Utils, C } from '@kineticdata/bundle-common';
const { withPayload } = Utils;
const ns = Utils.namespaceBuilder('services/portfolio');

export const types = {
  FETCH_PORTFOLIO_REQUEST: ns('FETCH_PORTFOLIO_REQUEST'),
  FETCH_PORTFOLIO_SUCCESS: ns('FETCH_PORTFOLIO_SUCCESS'),
  FETCH_PORTFOLIO_FAILURE: ns('FETCH_PORTFOLIO_FAILURE'),
};

export const actions = {
  fetchPortfolioRequest: withPayload(types.FETCH_PORTFOLIO_REQUEST),
  fetchPortfolioSuccess: withPayload(types.FETCH_PORTFOLIO_SUCCESS),
  fetchPortfolioFailure: withPayload(types.FETCH_PORTFOLIO_FAILURE),
};

export const State = Record({
  id: null,
  data: null,
  loading: false,
  error: null,
});

export const reducer = (state = State(), { type, payload }) => {
  switch (type) {
    case types.FETCH_PORTFOLIO_REQUEST:
      return state
        .set('id', payload)
        .update(
          'data',
          d => (!d || d.values[C.FIELD_PORTFOLIO_ID] !== payload ? null : d),
        )
        .set('loading', true)
        .set('error', null);
    case types.FETCH_PORTFOLIO_SUCCESS:
      return payload.id === state.id
        ? state.set('data', payload.data).set('loading', false)
        : state;
    case types.FETCH_PORTFOLIO_FAILURE:
      return payload.id === state.id
        ? state.set('error', payload.error).set('loading', false)
        : state;
    default:
      return state;
  }
};

export default reducer;
